import React from "react";
import ReactWOW from "react-wow";
import shopeeBannerIcon from "@apgm/assets/images/Overview_header.png";

class Banner extends React.Component {
  render() {
    const { className } = this.props;
    return (
      <section id="banner" className={className}>
        <div className="banner-content">
          <ReactWOW animation="bounceIn" delay="0.8s">
            <img
              src={shopeeBannerIcon}
              alt={shopeeBannerIcon}
              className="shopee-banner-icon"
            />
          </ReactWOW>
        </div>
      </section>
    );
  }
}

export default Banner;
